export default "__VITE_ASSET__BWVfTMsN__"